import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type AbortPinPostProps = {
  ledgerId: number;
  id: number;
  isSession?: boolean;
};

const useAbortSplitPaymentPinPost = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      ledgerId,
      id,
      isSession = false,
    }: AbortPinPostProps): Promise<void> => {
      if (isSession) {
        return post2(
          `internal/secure/pos/v1/payments/pos-terminal-abort/session_splitpayment/${ledgerId}/${id}/${branchId}`
        );
      } else {
        return post2(
          `internal/secure/pos/v1/payments/pos-terminal-abort/splitpayment/${ledgerId}/${id}/${branchId}`
        );
      }
    },
    onSuccess: () => {
      toast.success(t("success.delete"));
    },
  });

  return mutation;
};

export default useAbortSplitPaymentPinPost;
